__turbopack_context__.v({
  "Overlay": "LoadingOverlay-module-scss-module__C7acKq__Overlay",
  "Overlay___blurred": "LoadingOverlay-module-scss-module__C7acKq__Overlay___blurred",
});
